  <!-- 确认修改 -->
<template>
<div class="check-shensu" >
  <div class="shensu-info">
      <div class="head-title-main"><i class="el-icon-warning danger"></i>请确认是否同意提成类型的被修改结果</div>
      <div class="button-con button-con-right">
        <el-button class="btn-cancel" plain @click="$emit('dialogVisible')">取 消</el-button>
        <el-button class="btn-ok" type="primary" @click="confirmModify"  :loading="loading">确定</el-button>
      </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'check-shensu',
  data () {
    return {
      loading: false
    }
  },
  props: {
    orderObj: { // 订单
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    // 确认修改
    confirmModify () {
      this.loading = true
      // console.log('>>>', this.orderObj.orderId)
      this.$api.orderBonusConfirm(this.orderObj.orderId).then((res) => {
        if (res.code === 0) {
          this.$message.success('已确认修改')
          this.$emit('submitState')
        }
        this.loading = false
      }).catch((err) => {
        console.log(err)
        this.$emit('closeDialog')
        this.loading = false
      })
    },
  }
}
</script>

